// @flow

async function HttpRequest(
    url: string,
    options: any = {},
    resultType: string = 'json'
): Promise<any> {
    var response = '';
    var error = '';
    try {
        const httpResponse = await fetch(url, options);
        if (httpResponse.ok) {
            if (resultType === 'text') {
                const plainText = await httpResponse.text();
                response = plainText;
            } else {
                const json = await httpResponse.json();
                response = json;
            }
        } else {
            error = httpResponse.status;
        }
    } catch (exp) {
        error = exp;
    }
    return { response, error };
}
export default HttpRequest;
